// Auto generated file, do not manually modify!
// com.hotpads.cometuserauthdtos.identityverification.CometUserIdentityVerificationDisplayStatus

export enum CometUserIdentityVerificationDisplayStatus {
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  NOT_STARTED = 'NOT_STARTED',
  VERIFIED = 'VERIFIED',
}

export const CometUserIdentityVerificationDisplayStatus_values = [
  CometUserIdentityVerificationDisplayStatus.EXPIRED,
  CometUserIdentityVerificationDisplayStatus.FAILED,
  CometUserIdentityVerificationDisplayStatus.IN_PROGRESS,
  CometUserIdentityVerificationDisplayStatus.NEEDS_REVIEW,
  CometUserIdentityVerificationDisplayStatus.NOT_STARTED,
  CometUserIdentityVerificationDisplayStatus.VERIFIED,
] as const;
